import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    scrollContainer: {
      height: "80vh",
      overflow: "auto",
      overflowX: "hidden",
    },
    scroll: {
      position: "relative",
      width: "100%",

      height: "80%",
    },
  })
);

export default useStyles;
